(function () {
  'use strict';

  var MOBILE_BP = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_BP;
  }

  function initCustomerStories(wrapper) {
    var track      = wrapper.querySelector('.cs-track');
    var trackOuter = wrapper.querySelector('.cs-track-outer');
    var dotsWrap   = wrapper.querySelector('.cs-dots');
    var toggleBtn  = wrapper.querySelector('.cs-controls__toggle');
    var modeBtn    = wrapper.querySelector('.cs-controls__mode-switch');
    var prevBtn    = wrapper.querySelector('.cs-arrow--prev');
    var nextBtn    = wrapper.querySelector('.cs-arrow--next');

    var cards      = Array.from(wrapper.querySelectorAll('.cs-card:not(.cs-card--clone)'));
    var totalReal  = cards.length;
    var currentIdx = 0;
    var virtualIdx = 0;
    var allTrackCards = [];
    var paused     = false;
    var stopTimer  = null;
    var snapTimer  = null;

    var modeDesktop    = wrapper.dataset.modeDesktop    || 'marquee';
    var modeMobile     = wrapper.dataset.modeMobile     || 'marquee';
    var stopDuration   = parseInt(wrapper.dataset.stopDuration, 10)   || 2500;
    var stopTransition = parseInt(wrapper.dataset.stopTransition, 10) || 600;

    // Resolve which mode applies at the current viewport width
    function resolveMode() {
      return isMobile() ? modeMobile : modeDesktop;
    }

    /* ---- DOTS ---- */
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'cs-dot' + (i === currentIdx ? ' cs-dot--active' : '');
        dot.setAttribute('aria-label', 'Go to story ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.cs-dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('cs-dot--active', i === currentIdx);
      });
    }

    /* ---- STOP MOTION — infinite clone buffer ---- */
    function buildInfiniteClones() {
      track.querySelectorAll('.cs-card--clone').forEach(function (c) { c.remove(); });

      // Append clones at the END (forward overflow)
      cards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.classList.add('cs-card--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      // Prepend clones at the START (backward overflow)
      for (var i = 0; i < totalReal; i++) {
        var clone = cards[i].cloneNode(true);
        clone.classList.add('cs-card--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.insertBefore(clone, cards[0]);
      }

      allTrackCards = Array.from(track.querySelectorAll('.cs-card'));
    }

    function getVirtualOffset(vIdx) {
      var outer    = wrapper.querySelector('.cs-track-outer');
      var outerW   = outer.offsetWidth;
      var card     = allTrackCards[vIdx];
      var cardLeft = card.offsetLeft;
      var cardW    = card.offsetWidth;
      return cardLeft - (outerW / 2) + (cardW / 2);
    }

    function applyOffset(vIdx, animate) {
      if (animate === false) {
        track.style.transition = 'none';
        track.offsetHeight;
      } else {
        track.style.transition = 'transform ' + stopTransition + 'ms cubic-bezier(0.4,0,0.2,1)';
      }
      var offset = Math.max(0, getVirtualOffset(vIdx));
      track.style.transform = 'translateX(-' + offset + 'px)';
    }

    function doSlide(newVIdx) {
      clearTimeout(snapTimer);

      applyOffset(newVIdx, true);

      virtualIdx = newVIdx;
      currentIdx = ((newVIdx - totalReal) % totalReal + totalReal) % totalReal;

      cards.forEach(function (c) { c.classList.remove('cs-card--active'); });
      cards[currentIdx].classList.add('cs-card--active');
      updateDots();

      snapTimer = setTimeout(function () {
        if (virtualIdx < totalReal || virtualIdx >= 2 * totalReal) {
          var correctedVIdx = currentIdx + totalReal;
          virtualIdx = correctedVIdx;
          applyOffset(correctedVIdx, false);
        }
      }, stopTransition + 20);
    }

    function next() {
      if (mode !== 'stopmotion') return;
      doSlide(virtualIdx + 1);
    }

    function prev() {
      if (mode !== 'stopmotion') return;
      doSlide(virtualIdx - 1);
    }

    function goTo(realIdx) {
      if (mode !== 'stopmotion') return;
      clearTimeout(stopTimer);
      currentIdx = ((realIdx % totalReal) + totalReal) % totalReal;
      virtualIdx = totalReal + currentIdx;
      applyOffset(virtualIdx, true);
      cards.forEach(function (c) { c.classList.remove('cs-card--active'); });
      cards[currentIdx].classList.add('cs-card--active');
      updateDots();
      scheduleNext();
    }

    function scheduleNext() {
      if (paused || mode !== 'stopmotion') return;
      clearTimeout(stopTimer);
      stopTimer = setTimeout(function () {
        next();
        scheduleNext();
      }, stopDuration + stopTransition);
    }

    function startStopMotion() {
      clearTimeout(stopTimer);
      clearTimeout(snapTimer);
      track.style.transition = 'none';
      track.style.transform  = '';

      buildInfiniteClones();

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          virtualIdx = totalReal;
          currentIdx = 0;

          buildDots();
          applyOffset(virtualIdx, false);

          cards.forEach(function (c) { c.classList.remove('cs-card--active'); });
          cards[0].classList.add('cs-card--active');
          updateDots();

          if (!paused) scheduleNext();
        });
      });
    }

    /* ---- MARQUEE ---- */
    function startMarquee() {
      clearTimeout(stopTimer);
      clearTimeout(snapTimer);
      track.style.transition = '';
      track.style.transform  = '';
      cards.forEach(function (c) { c.classList.remove('cs-card--active'); });

      track.querySelectorAll('.cs-card--clone').forEach(function (c) { c.remove(); });

      // Build marquee clones (append only)
      cards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.classList.add('cs-card--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      if (dotsWrap) dotsWrap.innerHTML = '';
    }

    /* ---- MODE SWITCH ---- */
    var mode = resolveMode();

    function setMode(newMode) {
      mode = newMode;
      wrapper.dataset.mode = newMode;
      if (newMode === 'stopmotion') {
        startStopMotion();
      } else {
        startMarquee();
      }
    }

    /* ---- PAUSE / PLAY ---- */
    function setPaused(val) {
      paused = val;
      wrapper.classList.toggle('cs-paused', paused);
      if (toggleBtn) {
        toggleBtn.querySelector('.cs-controls__icon--pause').style.display = paused ? 'none'  : 'flex';
        toggleBtn.querySelector('.cs-controls__icon--play').style.display  = paused ? 'flex'  : 'none';
      }
      if (mode === 'stopmotion') {
        if (paused) {
          clearTimeout(stopTimer);
        } else {
          scheduleNext();
        }
      }
    }

    /* ---- RESPONSIVE: switch mode on breakpoint crossing ---- */
    var lastWasMobile = isMobile();
    window.addEventListener('resize', function () {
      var nowMobile = isMobile();
      if (nowMobile !== lastWasMobile) {
        lastWasMobile = nowMobile;
        setMode(resolveMode());
      }
    });

    /* ---- ARROWS ---- */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (mode === 'stopmotion') {
          clearTimeout(stopTimer);
          prev();
          scheduleNext();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (mode === 'stopmotion') {
          clearTimeout(stopTimer);
          next();
          scheduleNext();
        }
      });
    }

    /* ---- CONTROLS ---- */
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        setPaused(!paused);
      });
    }

    if (modeBtn) {
      modeBtn.addEventListener('click', function () {
        // Manual override toggles from current active mode
        setMode(mode === 'marquee' ? 'stopmotion' : 'marquee');
      });
    }

    /* ---- TOUCH / DRAG SWIPE for stop motion ---- */
    var touchStartX = null;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    wrapper.addEventListener('touchend', function (e) {
      if (touchStartX === null || mode !== 'stopmotion') return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        clearTimeout(stopTimer);
        if (diff > 0) { next(); } else { prev(); }
        scheduleNext();
      }
      touchStartX = null;
    }, { passive: true });

    /* ---- PAUSE MARQUEE ON TRACK HOVER ONLY ---- */
    trackOuter.addEventListener('mouseenter', function () {
      if (mode === 'marquee') wrapper.classList.add('cs-paused');
    });
    trackOuter.addEventListener('mouseleave', function () {
      if (mode === 'marquee' && !paused) wrapper.classList.remove('cs-paused');
    });

    /* ---- INIT ---- */
    setMode(resolveMode());
  }

  /* Boot all instances on page */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cs-wrapper').forEach(initCustomerStories);
  });

})();